/* AL BAIT. — ouverture différée du volet « Pour le faire fumer »
 *
 * Le volet est replié par défaut : c'est ce qui rend le panier lisible sur
 * mobile, la liste des articles n'étant plus recouverte par le pied collant.
 * Il s'ouvre ensuite de lui-même, une seconde et demie après l'ouverture du
 * tiroir — le temps que le regard ait fait le tour de ce qu'il vient
 * d'ajouter.
 *
 * Aucun réglage FullStack ne fait cela : `open_by_default` ouvre à
 * l'affichage, pas après un délai. D'où ce fichier.
 *
 * Trois garde-fous, parce qu'un panier n'est pas un endroit où surprendre :
 *   - si la personne a déjà touché au volet pendant cette ouverture, on ne
 *     lui reprend pas la main ;
 *   - si elle l'a refermé une fois, on ne le rouvre plus de la session ;
 *   - `prefers-reduced-motion` supprime le délai plutôt que l'ouverture :
 *     le volet est ouvert d'emblée, il n'y a donc aucun mouvement.
 */
(() => {
  const DELAI = 1500;
  const CLE_REFUS = 'al-bait:panier-cross-sell-referme';

  const refuse = () => {
    try {
      return sessionStorage.getItem(CLE_REFUS) === '1';
    } catch {
      return false;
    }
  };

  const memoriserRefus = () => {
    try {
      sessionStorage.setItem(CLE_REFUS, '1');
    } catch {
      /* navigation privée : on se contente de l'oublier */
    }
  };

  /* Le volet visé est celui du pied du tiroir, pas un accordéon de fiche
   * produit qui se trouverait dans le même document. */
  const volet = (tiroir) =>
    tiroir.querySelector('.cart-drawer__footer [data-ref="accordion-details"]');

  let minuterie = null;

  const programmer = (tiroir) => {
    clearTimeout(minuterie);
    const details = volet(tiroir);
    if (!details || details.open || refuse()) return;

    /* Une intervention de la personne annule l'ouverture automatique. */
    const annuler = () => clearTimeout(minuterie);
    details.addEventListener('toggle', annuler, { once: true });

    const ouvrir = () => {
      if (details.open || refuse()) return;
      details.open = true;
      /* Refermer manuellement vaut refus pour le reste de la session. */
      details.addEventListener(
        'toggle',
        () => {
          if (!details.open) memoriserRefus();
        },
        { once: true }
      );
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ouvrir();
      return;
    }
    minuterie = setTimeout(ouvrir, DELAI);
  };

  const surveiller = (tiroir) => {
    if (tiroir.dataset.alBaitCrossSell === '1') return;
    tiroir.dataset.alBaitCrossSell = '1';

    if (tiroir.classList.contains('is-open')) programmer(tiroir);

    new MutationObserver(() => {
      if (tiroir.classList.contains('is-open')) programmer(tiroir);
      else clearTimeout(minuterie);
    }).observe(tiroir, { attributes: true, attributeFilter: ['class'] });
  };

  const init = () => {
    document.querySelectorAll('cart-drawer').forEach(surveiller);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Le tiroir est réécrit à chaque mise à jour du panier : on réattache. */
  document.addEventListener('cart:updated', init);
})();
